import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import PropTypes from 'prop-types';
import * as React from 'react';
import { TIPO_ENTIDAD } from '../../constants/FieldsConst';
import { validFielddHelper } from '../../helpers/ValidFieldsHelper';

export const tiposEntidadEnums = [
  { id: 'PUBLICA', nombre: 'PUBLICA' },
  { id: 'PRIVADA', nombre: 'PRIVADA' },
  { id: 'MIXTA', nombre: 'MIXTA' },
  { id: 'PERSONAL', nombre: 'PERSONAL' },
  { id: 'BANDA', nombre: 'BANDA' },
];

const TiposEntidadField = ({
  onChange,
  required,
  value,
  helperText,
  error,
  disabled = false,
}) => {
  const xName = 'Tipo de entidad';

  return (
    <FormControl
      fullWidth
      error={error}
      size="small"
      required={required}
      disabled={disabled}
    >
      <InputLabel id={TIPO_ENTIDAD}>{xName}</InputLabel>
      <Select
        labelId={TIPO_ENTIDAD}
        id={TIPO_ENTIDAD}
        value={value}
        label={xName}
        onChange={onChange}
      >
        {tiposEntidadEnums.map((item) => {
          return (
            <MenuItem key={item.id} value={item.id}>
              {item.nombre}
            </MenuItem>
          );
        })}
      </Select>
      {error && (
        <FormHelperText>
          {helperText ?? (error ? validFielddHelper(1) : null)}
        </FormHelperText>
      )}
    </FormControl>
  );
};

TiposEntidadField.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default TiposEntidadField;
